import { render, staticRenderFns } from "./setCollectionAccountModal.vue?vue&type=template&id=b51dd596&scoped=true"
import script from "./setCollectionAccountModal.vue?vue&type=script&lang=js"
export * from "./setCollectionAccountModal.vue?vue&type=script&lang=js"
import style0 from "./setCollectionAccountModal.vue?vue&type=style&index=0&id=b51dd596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51dd596",
  null
  
)

export default component.exports